<template>
  <div class="bg-grey-lines">
    <transition name="fade" mode="out-in">
      <section class="box-full box-form" id="formSegment" :key="1" v-if="stepCurrent == 1">
        <h1 class="title">
          <span>Escolha</span> <span>seu</span> <span>segmento</span> <span>para</span> <span class="active">finalizar</span>
        </h1>
        <div class="box-select">
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="1" class="box-item" :class="{ active: segmentCurrent == 1 }">Agência de Marketing e Publicidade</a>
            <a href="#" @click.prevent="selectBox" data-id="2" class="box-item" :class="{ active: segmentCurrent == 2 }">Consultorias e Treinamentos</a>
            <a href="#" @click.prevent="selectBox" data-id="3" class="box-item" :class="{ active: segmentCurrent == 3 }">E-commerce</a>
          </div>
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="4" class="box-item" :class="{ active: segmentCurrent == 4 }">Educação e Ensino</a>
            <a href="#" @click.prevent="selectBox" data-id="5" class="box-item" :class="{ active: segmentCurrent == 5 }">Engenharia e Indústria Geral</a>
            <a href="#" @click.prevent="selectBox" data-id="6" class="box-item" :class="{ active: segmentCurrent == 6 }">Eventos</a>
          </div>
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="7" class="box-item" :class="{ active: segmentCurrent == 7 }">Financeiro, Jurídico e  relacionados</a>
            <a href="#" @click.prevent="selectBox" data-id="8" class="box-item" :class="{ active: segmentCurrent == 8 }">Governo e Órgãos Públicos</a>
            <a href="#" @click.prevent="selectBox" data-id="9" class="box-item" :class="{ active: segmentCurrent == 9 }">Hardware e Eletrônicos</a>
          </div>
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="10" class="box-item" :class="{ active: segmentCurrent == 10 }">Imobiliárias</a>
            <a href="#" @click.prevent="selectBox" data-id="11" class="box-item" :class="{ active: segmentCurrent == 11 }">Mídia e Comunicação</a>
            <a href="#" @click.prevent="selectBox" data-id="12" class="box-item" :class="{ active: segmentCurrent == 12 }">ONGs</a>
          </div>
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="13" class="box-item" :class="{ active: segmentCurrent == 13 }">Saúde e Estética</a>
            <a href="#" @click.prevent="selectBox" data-id="14" class="box-item" :class="{ active: segmentCurrent == 14 }">Serviços em RH e Coaching</a>
            <a href="#" @click.prevent="selectBox" data-id="15" class="box-item" :class="{ active: segmentCurrent == 15 }">Software e Cloud</a>
          </div>
          <div class="row">
            <a href="#" @click.prevent="selectBox" data-id="16" class="box-item" :class="{ active: segmentCurrent == 16 }">Telecomunicações</a>
            <a href="#" @click.prevent="selectBox" data-id="17" class="box-item" :class="{ active: segmentCurrent == 17 }">Turismo e Lazer</a>
            <a href="#" @click.prevent="selectBox" data-id="18" class="box-item" :class="{ active: segmentCurrent == 18 }">Varejo</a>
          </div>
        </div>

        <div class="box-full-footer">
          <v-button to="/estrategia/formulario" class='btn-prev' super-dark arrow-left>
            Voltar
          </v-button>
          <icon name="td-logo" class='td-logo' color="#393f49" />
          <v-button v-if="segmentCurrent" class='btn-next' @click.prevent.native="nextStep" super-dark arrow>
            Avançar
          </v-button>
          <v-button v-else class="btn-next" super-dark>
            Selecione um segmento
          </v-button>
        </div>
      </section>

      <section class="box-full box-form" :key="2" v-if="stepCurrent == 2">
        <h1 class="title title-form">Insira seus dados</h1>

        <div class="form-steps" id="forms">
          <a href="#" @click.prevent="prevForm()" class="nav-arrow nav-left" :class="{ 'v-hidden': stepFormCurrent == 1 }">
            <icon name="arrow-right" half></icon>
          </a>
          <transition name="fade" mode="out-in">
            <form v-if="stepFormCurrent == 1" @submit.prevent="nextForm()" :key="1"
              class="form-step">
              <input type="text" class="form-input" name="firstname" required
                v-model="form.firstname" placeholder="Nome" @input="inputChange">
              <input type="email" class="form-input" name="email" v-model="form.email"
                placeholder="Email" @input="inputChange" :class="{ error: errorValidationForm.email }"
                required>
              <input type="empresa" class="form-input" name="company" required
                v-model="form.company" placeholder="Empresa" @input="inputChange">
              <v-multiselect :class='{ error: errorValidationForm.estado_sigla }'
                autocomplete="off"
                :options='state'
                :show-labels='false'
                placeholder='Estado'
                label='state'
                v-model='form.estado_sigla'
                :value='form.estado_sigla'
                track-by='sigla'
                id='estado_sigla'
                @select='multiselectChange' />
              <v-multiselect :class='{ error: errorValidationForm.business_model }'
                :options='model'
                :show-labels='false'
                placeholder='Modelo de negócio'
                v-model='form.business_model'
                id='business_model'
                @select='multiselectChange' />
                <button type="submit" hidden ref="submitStep1" />
            </form>
            <div class="form-step" v-if="stepFormCurrent == 2" :key="2">
              <v-multiselect :class='{ error: errorValidationForm.numemployees }'
                :options='employees'
                :show-labels='false'
                placeholder='Quantidade de funcionários'
                v-model='form.numemployees'
                id='numemployees'
                @select='multiselectChange' />
              <v-multiselect :class='{ error: errorValidationForm.td_cargo }'
                :options='role'
                :show-labels='false'
                placeholder='Cargo'
                v-model='form.td_cargo'
                id='td_cargo'
                @select='changeCargo' />
              <v-multiselect
                v-if='form.td_cargo === "Diretor (C-Level)"'
                :options='roleFunction'
                :show-labels='false'
                placeholder='Qual opção melhor se encaixa na sua função?'
                v-model='form.clevel_funcao'
                id='clevel_funcao'
                @select='multiselectChange' />
              <v-multiselect :class='{ error: errorValidationForm.departamento }'
                :options='departament'
                :show-labels='false'
                placeholder='Departamento'
                v-model='form.departamento'
                id='departamento'
                @select='multiselectChange' />
              <v-multiselect :class='{ error: errorValidationForm.papel_td }'
                :options='transformationDigital'
                :show-labels='false'
                placeholder='Qual papel você exerce na transformação digital da sua empresa?'
                v-model='form.papel_td'
                id='papel_td'
                @select='multiselectChange' />
            </div>
          </transition>
          <a href="#" @click.prevent="checkForm1" class="nav-arrow nav-right" :class="{ 'v-hidden': stepFormCurrent == 2 }">
            <icon name="arrow-right" half></icon>
          </a>
          <div class="nav-lines">
            <a href="#" class="line" @click.prevent="setForm(1)">
              <div class="block" :class="{ active: stepFormCurrent == 1 }"></div>
            </a>
            <a href="#" class="line" @click.prevent="checkForm1">
              <div class="block" :class="{ active: stepFormCurrent == 2 }"></div>
            </a>
          </div>
        </div>

        <div class="box-full-footer">
          <v-button @click.prevent.native="prevStep" class='btn-prev' super-dark arrow-left>
            Voltar
          </v-button>
          <icon name="td-logo" class='td-logo' color="#393f49" />
          <v-button v-if="hasError" @click.prevent.native="checkAllForm" class='btn-next' super-dark>
            Preencha o formulário
          </v-button>
          <v-button v-else @click.prevent.native="checkForm2" class='btn-next' super-dark arrow>
            Avançar
          </v-button>
        </div>

      </section>
    </transition>
  </div>
</template>

<script>
import Icon from './Icon';
import vButton from './vButton';

/* eslint-disable max-len */
export default {
  name: 'diagnosis',
  components: { Icon, vButton },
  data() {
    return {
      segmentCurrent: 0,
      stepCurrent: 1,
      stepFormCurrent: 1,
      errorValidationForm: {
        email: false,
        estado_sigla: false,
        business_model: false,
        numemployees: false,
        td_cargo: false,
        departamento: false,
        papel_td: false,
      },
      hasError: true,
      // industry: ['Agência de Marketing/Publicidade', 'Tecnologia', 'Educação', 'Software e Cloud', 'Educação Superior', 'e-commerce', 'Varejo', 'Consultoria', 'Mídia e Comunicação', 'Turismo e Lazer', 'Saúde', 'RH e Recrutamento', 'Dinheiro e Finanças', 'Serviços Corporativos', 'Jurídico', 'Industria e Manufatura', 'Outros'],
      state: [{ sigla: 'AC', state: 'Acre' }, { sigla: 'AL', state: 'Alagoas' }, { sigla: 'AM', state: 'Amazonas' }, { sigla: 'AP', state: 'Amapá' }, { sigla: 'BA', state: 'Bahia' }, { sigla: 'CE', state: 'Ceará' }, { sigla: 'DF', state: 'Distrito Federal' }, { sigla: 'ES', state: 'Espírito Santo' }, { sigla: 'GO', state: 'Goiás' }, { sigla: 'MA', state: 'Maranhão' }, { sigla: 'MT', state: 'Mato Grosso' }, { sigla: 'MS', state: 'Mato Grosso do Sul' }, { sigla: 'MG', state: 'Minas Gerais' }, { sigla: 'PA', state: 'Pará' }, { sigla: 'PB', state: 'Paraíba' }, { sigla: 'PR', state: 'Paraná' }, { sigla: 'PE', state: 'Pernambuco' }, { sigla: 'PI', state: 'Piauí' }, { sigla: 'RJ', state: 'Rio de Janeiro' }, { sigla: 'RN', state: 'Rio Grande do Norte' }, { sigla: 'RS', state: 'Rio Grande do Sul' }, { sigla: 'RO', state: 'Rondônia' }, { sigla: 'RR', state: 'Roraima' }, { sigla: 'SC', state: 'Santa Catarina' }, { sigla: 'SE', state: 'Sergipe' }, { sigla: 'SP', state: 'São Paulo' }, { sigla: 'TO', state: 'Tocantins' }],
      model: ['B2B', 'B2C'],
      employees: ['Individual', '2-5', '5-25', '25-50', '50-100', '100-200', '200-500', '500-1000', '1000+'],
      role: ['Diretor (C-Level)', 'Gerente / Coordenador', 'Supervisor', 'Analista', 'Assistente', 'Estagiário'],
      roleFunction: ['CEO (Chief Executive Officer)', 'COO (Chief Operating Officer)', 'CFO (Chief Financial Officer)', 'CDO (Chief Digital Officer)', 'CTO (Chief Technology Officer)', 'CIO (Chief Information Officer)', 'CMO (Chief Marketing Officer)', 'CHRO (Chief Human Resources Officer)', 'Outros'],
      departament: ['Comercial', 'Financeiro', 'Gestão', 'Marketing', 'Pós-venda', 'Produto', 'Recursos Humanos', 'Tecnologia'],
      transformationDigital: ['Sou o responsável formal pela transformação em minha empresa', 'Não há responsável, mas estou iniciando o movimento', 'Apenas sou interessado pelo assunto'],
      form: {
        ...this.$store.state.diagnosis
      },
    };
  },
  mounted() {
    this.autoSelectSegment();
    this.$store.commit('SET_BAR_PROGRESS', 6);
  },
  methods: {
    /* eslint-disable no-useless-escape */
    checkAllForm() {
      this.stepFormCurrent === 1 ? this.checkForm1() : this.checkForm2()
    },
    checkForm1() {
      const fields = ['email', 'estado_sigla', 'business_model'];
      this.hasError = false;
      fields.forEach((field) => {
        if (!this.form[field]) {
          this.errorValidationForm[field] = true;
          this.hasError = true;
        }
      })
      if (this.hasError) {
        this.stepFormCurrent = 1;
      } else {
        this.$refs.submitStep1.click();
        this.hasError = true;
      }
    },
    checkForm2() {
      const fields = ['numemployees', 'td_cargo', 'departamento', 'papel_td'];
      this.hasError = false;
      fields.forEach((field) => {
        if (!this.form[field]) {
          this.errorValidationForm[field] = true;
          this.hasError = true;
        }
      })
      this.hasError ? this.stepFormCurrent = 2 : this.$router.push('/conclusao')
    },
    autoSelectSegment() {
      this.$el.querySelectorAll('.box-select .box-item').forEach((item) => {
        if (item.text === this.form.industry)
          this.segmentCurrent = item.dataset.id
      });
    },
    setForm(step) {
      this.stepFormCurrent = step;
    },
    selectBox(e) {
      this.segmentCurrent = e.target.dataset.id
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: 'industry',
        value: e.target.text
      })
    },
    multiselectChange(newValue, id) {
      this.errorValidationForm[id] = false;
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: id,
        value: Object.keys(newValue).includes('sigla') ? newValue.sigla : newValue
      })
    },
    inputChange(e) {
      const nameField = e.target.getAttribute('name')
      const newValue = e.target.value
      this.$store.commit('UPDATE_FIELD', {
        form: 'diagnosis',
        key: nameField,
        value: newValue
      })
    },
    changeCargo(value, id) {
      this.multiselectChange(value, id)
      if (value !== 'Diretor (C-Level)') {
        this.$store.commit('UPDATE_FIELD', {
          form: 'diagnosis',
          key: 'clevel_funcao',
          value: ''
        })
        this.form.clevel_funcao = ''
      }
    },
    nextForm() {
      this.stepFormCurrent = 2;
    },
    prevForm() {
      this.stepFormCurrent = 1;
    },
    nextStep() {
      this.stepCurrent += 1;
    },
    prevStep() {
      this.stepCurrent -= 1;
    },
  },
};

</script>

<style lang="scss" scoped>
  .box-full {
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 576px) {
      height: auto;
    }
    .title {
      margin: 0;
      padding: 42px 0 23px;
      letter-spacing: 10px;
      text-indent: 10px;
      text-transform: uppercase;
      @media (max-width: 576px) {
        line-height: 48px;
      }
      .active {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: -17%;
          left: -12%;
          right: 0;
          bottom: 0;
          background-color: rgba(white, .102);
          height: 130%;
          width: 120%;
        }
      }
    }
    .box-select {
      width: 90%;
      margin: 0 auto;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
      @media (max-width: 576px) {
        display: block;
      }
      .row {
        display: flex;
        justify-content: center;
        flex: 1;
        @media (max-width: 576px) {
          flex-direction: column;
        }
      }
      .box-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        text-decoration: none;
        color: #a4a8b1;
        padding: 22px 15px;
        background-color: rgba(black, .1);
        margin: 12px 15px;
        letter-spacing: 1px;
        text-indent: 1px;
        position: relative;
        flex: 1;
        transition: color .3s, background-color .3s, box-shadow .3s;
        &:hover,
        &.active {
          color: white;
          background-color: rgba(black, .2);
          box-shadow: 0 21px 25.23px 3.77px rgba(0, 0, 0, 0.1),
                      0 0 17px 0 rgba(0, 0, 0, 0.1);
        }
        &.active {
          background-color: rgba(white, .102);
          background-image: linear-gradient(-120deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.15) 100%);
        }
        @media (min-width: 576px) and (max-width: 991px) {
          padding-top: 26px;
          padding-bottom: 26px;
        }
        @media (max-width: 575px) {
          margin: 8px 0;
        }
      }
    }
    .box-full-footer {
      margin-top: auto;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .td-logo {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      @media (max-width: 576px) {
        flex-direction: column;
        .btn-next {
          order: -2;
        }
        .td-logo {
          position: static;
          transform: none;
          margin: 30px 0 40px;
        }
      }
    }
    .form-steps {
      margin: auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      @media (max-width: 576px) {
        margin-bottom: 72px;
      }
    }
    .form-step {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-width: 500px;
      min-height: 364px;
      .multiselect:last-child {
        margin-bottom: 0;
      }
    }
  }

  .v-hidden {
    visibility: hidden;
  }

  @media (max-width: 576px) {
    #app {
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Diagnosis.vue